var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M332.8 109.556V263.876C332.8 292.116 309.84 314.996 281.6 314.996L179.2 315.076L92.08 364.356C90.32 365.716 88.32 366.276 86.4 366.276C81.44 366.276 76.8 362.356 76.8 356.676V315.076H51.2C23 315.076 0 292.116 0 263.876V109.556C0 82.0762 23 59.0762 51.2 59.0762H281.6C309.84 59.0762 332.8 82.0762 332.8 109.556ZM115.2 307.156L169.12 276.676H281.6C288.56 276.676 294.4 270.916 294.4 263.876V110.276C294.4 103.276 288.56 97.4762 281.6 97.4762H51.2C44.2 97.4762 38.4 103.276 38.4 110.276V263.876C38.4 270.916 44.2 276.676 51.2 276.676H115.2V307.156ZM204.8 366.276V340.676H243.2V366.276C243.2 373.236 248.96 379.076 256 379.076H342.88L396.8 409.556V379.076H460.8C467.76 379.076 473.6 373.236 473.6 366.276V212.676C473.6 205.716 467.76 199.876 460.8 199.876H358.4V161.476H460.8C489.04 161.476 512 184.436 512 211.956V366.276C512 394.516 489.04 417.476 460.8 417.476H435.2V459.076C435.2 464.756 430.56 468.676 425.6 468.676C423.68 468.676 421.68 468.116 419.92 466.756L332.8 417.476L256 417.396C227.84 417.396 204.8 394.516 204.8 366.276Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMessages);
export default __webpack_public_path__ + "static/media/my-messages.d9c2d239d5e0ab3325cfe79cdf25939b.svg";
export { ForwardRef as ReactComponent };